import type { Filter_FacetsFragment } from '@generated/graphql'

export const facetsFilteredFormatted = (
  filteredFacets?: Filter_FacetsFragment[]
) =>
  filteredFacets?.filter(
    (item) =>
      (item?.__typename === 'StoreFacetBoolean' && item?.values?.length > 1) ||
      item?.key === 'price'
  ) ?? []
